// Dourado vocabulary expansion — BODY & HEALTH theme (net-new cards).
//
// Extends the `body-health` blocks in ./vocabulary.js without reusing any
// headword already defined there. Seed upserts on `portuguese`, so every value is
// unique.
//   [ portuguese, english, emoji, part_of_speech, gender, example_pt, example_en ]

export const VOCAB_BODY_HEALTH = [
  {
    theme: "body-health", tier: "A1", rows: [
      ["a orelha", "ear", "👂", "noun", "f", "Dói-me a orelha esquerda.", "My left ear hurts."],
      ["o dente", "tooth", "🦷", "noun", "m", "Lavo os dentes depois de comer.", "I brush my teeth after eating."],
      ["o dedo", "finger", "🫰", "noun", "m", "Cortei o dedo.", "I've cut my finger."],
      ["as costas", "back", "🧍", "noun", "f", "Doem-me as costas à noite.", "My back hurts at night."],
      ["o pescoço", "neck", "🧣", "noun", "m", "Tenho o pescoço rígido.", "My neck is stiff."],
      ["o joelho", "knee", "🦵", "noun", "m", "Magoei o joelho.", "I hurt my knee."],
      ["o coração", "heart", "❤️", "noun", "m", "O coração bate muito depressa.", "The heart beats very fast."],
      ["o estômago", "stomach", "🤰", "noun", "m", "Dói-me o estômago.", "My stomach hurts."],
      ["a garganta", "throat", "🗣️", "noun", "f", "Tenho a garganta inflamada.", "My throat is sore."],
      ["o ombro", "shoulder", "💪", "noun", "m", "Levo a mochila num ombro.", "I carry the backpack on one shoulder."],
    ],
  },
  {
    theme: "body-health", tier: "A2", rows: [
      ["a constipação", "cold (illness)", "🤧", "noun", "f", "Tenho uma constipação muito forte.", "I have a bad cold."],
      ["a gripe", "flu", "🌡️", "noun", "f", "Está de cama com gripe.", "She's in bed with the flu."],
      ["a tosse", "cough", "😷", "noun", "f", "A tosse não me deixa dormir.", "The cough won't let me sleep."],
      ["a ligadura", "bandage", "🩹", "noun", "f", "O médico pôs-me uma ligadura.", "The doctor put a bandage on me."],
      ["o penso rápido", "plaster / band-aid", "🩹", "noun", "m", "Preciso de um penso rápido para o dedo.", "I need a plaster for my finger."],
      ["o xarope", "syrup (medicine)", "🍶", "noun", "m", "Toma o xarope para a tosse.", "Take the cough syrup."],
      ["a consulta", "doctor's office / appointment", "🏥", "noun", "f", "A consulta abre às nove.", "The surgery opens at nine."],
      ["doer", "to hurt", "😣", "verb", "", "Dói-me o corpo todo.", "My whole body aches."],
      ["engordar", "to put on weight", "⚖️", "verb", "", "Engordei dois quilos.", "I've put on two kilos."],
      ["emagrecer", "to lose weight", "📉", "verb", "", "Quer emagrecer para o verão.", "She wants to lose weight for the summer."],
    ],
  },
  {
    theme: "body-health", tier: "B1", rows: [
      ["o mal-estar", "discomfort / unwellness", "😖", "noun", "m", "Sinto um mal-estar geral.", "I feel a general unwellness."],
      ["o diagnóstico", "diagnosis", "🩺", "noun", "m", "O diagnóstico demorou uma semana.", "The diagnosis took a week."],
      ["a maleita", "ailment", "🤕", "noun", "f", "É uma maleita crónica mas ligeira.", "It's a chronic but mild ailment."],
      ["crónico", "chronic", "♾️", "adjective", "", "Sofre de dor crónica nas costas.", "He suffers from chronic back pain."],
      ["agudo", "acute / sharp", "⚡", "adjective", "", "Sentiu uma dor aguda no peito.", "He felt a sharp pain in his chest."],
      ["o internamento", "hospital admission", "🛏️", "noun", "m", "O internamento foi de urgência.", "The admission was an emergency."],
      ["a baixa médica", "sick leave", "📋", "phrase", "", "Está de baixa médica duas semanas.", "She's on sick leave for two weeks."],
      ["desmaiar", "to faint", "😵", "verb", "", "Desmaiou com o calor.", "He fainted from the heat."],
      ["a cicatriz", "scar", "➰", "noun", "f", "Ficou com uma cicatriz pequena.", "He was left with a small scar."],
      ["aliviar", "to relieve", "🌿", "verb", "", "O comprimido alivia a dor logo.", "The pill relieves the pain right away."],
    ],
  },
];
